var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('home.main.badges.new')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }